import iconInboundArrow from '~/assets/svgs/icon-inbound-arrow.svg?react'
import iconInternalArrow from '~/assets/svgs/icon-internal-arrow.svg?react'
import iconOutboundArrow from '~/assets/svgs/icon-outbound-arrow.svg?react'
import { CallOutcomeCellVariant } from '~/pages/Calls/componentStyles/CallsListItem.style'
import {
  ContactDetails,
  ContactNumberLabel,
} from '~/pages/Contacts/viewModels/Contacts.viewmodel'
import { hasValue, tryGetValueOrDefault } from '~/utils/common'
import { formatPhoneNumber } from '~/utils/formatter'

import {
  Call,
  CallDirection,
  Caller,
  CallStatus,
  ContactSourceType,
} from '@mangovoice/types'

export enum CallTarget {
  From = 'from',
  To = 'to',
}

const getTitleValue = (caller: Caller) => {
  if (caller?.user) {
    return caller.user.name
  }
  if (caller?.extension) {
    return caller.extension.name
  }
  if (caller?.caller_id && caller.caller_id !== '') {
    return caller.caller_id
  }
  if (caller?.phone_number?.name) {
    return caller.phone_number.name
  }
  if (caller?.cnam_location) {
    return caller.cnam_location
  }
  return 'Unknown Number'
}

export const getCallTargetData = (call: Call, target: CallTarget) => {
  const targetObj = call[target]

  const isExtension = hasValue(targetObj.extension)
  const titleValue = getTitleValue(targetObj)

  const numberValue = isExtension
    ? formatPhoneNumber(targetObj.extension?.number)
    : targetObj.formatted

  const subtitleValue = isExtension
    ? `${targetObj.extension?.name}`
    : numberValue

  const locationValue =
    tryGetValueOrDefault(targetObj.cnam_location) ??
    tryGetValueOrDefault(targetObj.location?.name)

  let contactValue: ContactDetails | undefined = undefined
  if (targetObj.user !== undefined && targetObj.user !== null) {
    const numberData = {
      id:
        (isExtension ? targetObj.extension?.id : targetObj.phone_number?.id) ??
        0,
      label: 'other' as ContactNumberLabel,
      number:
        (isExtension
          ? targetObj.extension?.number
          : targetObj.phone_number?.number) ?? '',
      isExtension: isExtension,
      availableActions: [],
      availableQuickActions: [],
    }
    contactValue = {
      id: targetObj.user.id,
      name: targetObj.user.name,
      numbers: [numberData],
      defaultNumber: numberData,
      source: ContactSourceType.Unknown,
      sourceName: 'Unknown',
    }
  }
  return {
    titleValue,
    subtitleValue,
    location:
      tryGetValueOrDefault(targetObj?.cnam_location) ??
      tryGetValueOrDefault(targetObj.location?.name),
    locationIsTitle: titleValue === locationValue,
    isExtension: hasValue(targetObj.extension?.number),
    number: numberValue,
    contact: contactValue,
  }
}

export const getCallOutcomeData = (call: Call) => {
  const { status, direction, is_missed } = call
  let text = ''
  const icon =
    direction === CallDirection.Inbound
      ? iconInboundArrow
      : direction === CallDirection.Internal
        ? iconInternalArrow
        : iconOutboundArrow

  let variant: CallOutcomeCellVariant = CallOutcomeCellVariant.Success
  switch (status) {
    case CallStatus.Completed:
      text = is_missed ? 'Missed' : 'Answered'
      variant = is_missed ? CallOutcomeCellVariant.Failure : variant
      break
    case CallStatus.InProgress:
      text = 'In Progress'
      variant = CallOutcomeCellVariant.InProgress
      break
    case CallStatus.Canceled:
    case CallStatus.Failed:
    case CallStatus.Busy:
      text = 'Failed'
      variant = CallOutcomeCellVariant.Failure
      break
  }

  return { text, icon, variant }
}
